// Fixed palette for creator tags, enforced server-side. The frontend should
// import this rather than maintaining its own copy.
export const CREATOR_TAG_COLORS = [
  "#ef4444", // red
  "#f97316", // orange
  "#f59e0b", // amber
  "#84cc16", // lime
  "#10b981", // emerald
  "#14b8a6", // teal
  "#0ea5e9", // sky
  "#3b82f6", // blue
  "#8b5cf6", // violet
  "#d946ef", // fuchsia
  "#ec4899", // pink
  "#64748b", // slate
] as const;

export type CreatorTagColor = (typeof CREATOR_TAG_COLORS)[number];
